import React from 'react';
import { Radio } from 'tea-component'; 
import BubbleCommon from '../../../BubbleCommon'; 
import { arrayToSimpleObj } from '@op/utils';
import useLanguage from '@op/hooks/useLanguage';

export type MonitorRuleType = 'include' | 'only_include';

interface ContentHeaderProps {
  monitorRule: MonitorRuleType;
  setMonitorRule: (value: MonitorRuleType) => void;
}

const ruleOptions = [
  {
    text: 'Contain',
    value: 'include' as MonitorRuleType,
    tips: {
      zh: (
        <>
          筛选包含所选来源的评论（此评论也可能提到其他来源）
          <br />
          例：选择来源A，提到A, A&B, 或者A&B&C来源的评论都会被统计
        </>
      ),
      en: (
        <>
          Select reviews that mention the chosen monitor sources (These reviews
          may also reference other monitor sources).
          <br />
          e.g. Select monitor source A, reviews that mention monitor sources A,
          A&B, or A&B&C will be included.
        </>
      ),
    },
  },
  {
    text: 'Only Contain',
    value: 'only_include' as MonitorRuleType,
    tips: {
      zh: (
        <>
          筛选仅包含所选来源的评论（评论的所有来源只限于所选范围内）
          <br />
          选择来源A、B，仅提到A来源、仅提到B来源或者仅提到来源A&B的评论会被统计
        </>
      ),
      en: (
        <>
          Select reviews that mention only the chosen monitor sources (Reviews
          from a single source only).
          <br />
          Select monitor sources A and B; reviews that mention only source A or
          only source B or source A&B will be included.
        </>
      ),
    },
  },
];

export const ruleOptionsMap = arrayToSimpleObj(ruleOptions, 'text', 'value');

export default function ContentHeader({
  monitorRule,
  setMonitorRule,
}: ContentHeaderProps) {
  const { formatMessage } = useLanguage();

  return (
    <div className="dbo-monitor-region">
      <Radio.Group
        value={monitorRule}
        onChange={(value: any) => setMonitorRule(value)}
      >
        {ruleOptions.map(({ text, value: ruleValue, tips }) => (
          <BubbleCommon
            tipsMap={tips}
            placement="top"
            showIcon={false}
            key={ruleValue}
          >
            <Radio name={ruleValue}>{formatMessage({ id: text })}</Radio>
          </BubbleCommon>
        ))}
      </Radio.Group>
    </div>
  );
}
